module.exports = __webpack_public_path__ + "static/media/sponsors.e3a67587.svg";